/* eslint-disable prettier/prettier */
import { MouseEventHandler, ReactElement } from "react";

const StyledButton = (props: {
  text: string;
  id?: string;
  title?: string;
  className?: string;
  additionalClassName?: string;
  onClick?: MouseEventHandler;
  disabled?: boolean;
}): ReactElement => {
  const coreStyles: string =
    "text-center h-[48px] border-solid border-1 rounded-md";
  const defaultColor: string = "bg-blue-600 text-white";
  const disabledStyle: string = "bg-gray-650 cursor-not-allowed";
  const activeStyle: string =
    "border-CostcoAction bg-blue-600 cursor-pointer";
  const buttonStyles: string = `${coreStyles} ${props.disabled ? disabledStyle : activeStyle
    } ${props.additionalClassName ? props.additionalClassName : ""} ${props.className ? props.className : defaultColor} `;
  return (
    <div className="mx-2 block">
      <button
        type="submit"
        id={props.id}
        data-testid={`styled-button-${props.id}`}
        disabled={props.disabled}
        className={`${buttonStyles} flex flex-row items-center justify-center`}
        onClick={props.onClick}
        title={props.title}
      >
        {props.text === "Search" && <div className="inline-block icon-search text-2xl pr-2" />}
        <p>{props.text}</p>
      </button>
    </div>
  );
};
export default StyledButton;
